module.exports = __webpack_public_path__ + "static/img/122.9d4ddc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/122.png
// module id = mMN8
// module chunks = 0